import { makeStyles } from '@material-ui/core';
import { tcsmColors } from '../../theme-constants/colors';

export const formInputErrorStyles = makeStyles((theme) => ({    
    errorArrow: {
        left: '16px',
        width: '0',
        height: '0',
        position: 'relative',
        borderColor: `transparent transparent ${tcsmColors.red} transparent`,
        borderStyle: 'solid',
        borderWidth: '6px',
    }, 
    errorMessage: {
        padding: theme.spacing(.5),
        background: tcsmColors.red,  
        borderRadius: '3px',        
        border: '0',
        color: 'white',      
    },
    errorWrapper: {
        '& .input-error': {
            '&:before': {
                content: '""',
                display: 'block',
                top: '-11px',
                left: '16px',
                width: '0',
                height: '0',
                position: 'absolute',
                borderColor: `transparent transparent ${tcsmColors.red} transparent`,
                borderStyle: 'solid',
                borderWidth: '6px',
                
            },
            '&.right-arrow': {
                '&:before': {
                    left: 'auto',
                    right: '16px',
                },
            },
            marginTop: '6px',
            padding: theme.spacing(.5),
            background: tcsmColors.red,
            borderRadius: '3px',
            border: '0',
            color: 'white',
            position: 'relative',
        },
        
    },
}));
